var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "password") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD10-Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parcours-1---Se-connecter-B\\xE9n\\xE9ficiaire",
    transform: "translate(-394.000000, -443.000000)",
    stroke: "#70767D",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(334.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(61.583333, 181.750000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -1.42108547e-14,
    y: 7.33333333,
    width: 12.8333333,
    height: 9.16666667,
    rx: 1.79666667
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.41666667,
    cy: 11.9166667,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,7.33333333 L2.75,3.66666667 C2.75,1.64162258 4.39162258,0 6.41666667,0 C8.44171075,0 10.0833333,1.64162258 10.0833333,3.66666667 L10.0833333,7.33333333",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.f5f987bb467cb2f6bab7b63477f6ede9.svg";
export { ForwardRef as ReactComponent };